import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "../journey/step-library"
import { Button, FlexContainer, H1, Body } from "@carrotfertility/carotene"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"
import { IlloPaperAirplaneUnderwater, IlloYirTelehealth } from "../../../views/atoms/Illustrations"
import { useHistory } from "react-router"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"

interface WonderfulStepsProps {
  viewName: string
  illustration: React.ReactNode
  description: string
}
function WonderfulStep({ viewName, illustration, description }: WonderfulStepsProps): JSX.Element {
  const { setShowBackButton, setShowProgressTracker } = useJourneyFlow()
  const { completeRoutingInfo } = useRoutingInfo()
  const history = useHistory()
  useStateMachine(viewName, null)

  useEffect(() => {
    setShowBackButton(false)
    setShowProgressTracker(false)
    completeRoutingInfo()
  }, [])

  return (
    <>
      <FlexContainer justifyContent="center" stack="medium">
        {illustration}
      </FlexContainer>
      <FlexContainer justifyContent="center">
        <H1 stack="tiny">Wonderful</H1>
      </FlexContainer>
      <FlexContainer justifyContent="center" stack="medium">
        <Body>{description}</Body>
      </FlexContainer>
      <FlexContainer stack="huge" justifyContent="center">
        <Button variant="primary" disabled={false} onClick={() => history.push("/")}>
          Go to Carrot home
        </Button>
      </FlexContainer>
    </>
  )
}

export function MessageWonderfulStep(): JSX.Element {
  return (
    <WonderfulStep
      viewName={Steps.MESSAGE_WONDERFUL}
      illustration={<IlloPaperAirplaneUnderwater />}
      description={"Watch your inbox for a message from us."}
    />
  )
}

export function ExpertChatWonderfulStep(): JSX.Element {
  return (
    <WonderfulStep
      viewName={Steps.EXPERT_CHAT_WONDERFUL}
      illustration={<IlloYirTelehealth />}
      description={"Watch your inbox for an invite to your upcoming expert chat."}
    />
  )
}
